import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { LOGOUT_DELAY_MINUTES } from '../../config/inactivity';

const InactivityModal = ({ open, onLogout }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (open) {
      setProgress(100); // Reset progress when modal opens
      const totalSeconds = LOGOUT_DELAY_MINUTES * 60;
      const decrement = 100 / totalSeconds; // Calculate decrement based on total seconds

      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev <= decrement) {
            clearInterval(interval);
            onLogout(); // Trigger logout when timer reaches zero
            return 0;
          }
          return prev - decrement;
        });
      }, 1000);

      return () => clearInterval(interval); // Cleanup timer on close
    }
  }, [open, onLogout]);

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: 4,
          background: 'linear-gradient(145deg, #f9f9f9, #ffffff)',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: '#3f51b5',
          color: '#fff',
          fontSize: '1.5rem',
          textAlign: 'center',
          padding: '16px 24px',
        }}
      >
        ⚠️ Inactivity Warning
      </DialogTitle>
      <DialogContent
        sx={{
          padding: '24px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100px',
            height: '100px',
            marginBottom: '16px',
            marginTop: '16px',
          }}
        >
          {/* Circular countdown */}
          <CircularProgress
            variant="determinate"
            value={progress}
            size={100}
            thickness={4}
            sx={{
              color: '#f50057', // Countdown circle color
            }}
          />
          {/* Hourglass */}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '50%',
              width: '80px',
              height: '80px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: '#ffffff', // White background for contrast
            }}
          >
            <Typography
              sx={{
                fontSize: '2rem',
                fontWeight: 'bold',
                color: '#f50057',
              }}
            >
              ⏳
            </Typography>
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: '1.2rem',
            fontWeight: '500',
            color: '#555',
            marginBottom: '8px',
          }}
        >
          You have been inactive for a while.
        </Typography>
        <Typography
          sx={{
            fontSize: '1rem',
            fontWeight: '400',
            color: '#777',
          }}
        >
          Move your mouse or interact with the page within {LOGOUT_DELAY_MINUTES}{' '}
          {LOGOUT_DELAY_MINUTES === 1 ? 'minute' : 'minutes'} to continue using the site.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default InactivityModal;
